import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IxModule } from '@siemens/ix-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProjectCalculationComponent } from './project-calculation/project-calculation.component';
import { BasicInfoComponent } from './project-calculation/basic-info/basic-info.component';
import { EquipmentInventoryComponent } from './project-calculation/equipment-inventory/equipment-inventory.component';
import { ServicesComponent } from './project-calculation/services/services.component';
import { ContractComponent } from './project-calculation/contract/contract.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { environment as env } from '../environments/environment';
import { AppFrameComponent } from './app-frame/app-frame.component';
import { MasterfileManagementComponent } from './masterfile-management/masterfile-management.component';
import { AdminProjectOverviewComponent } from './admin-project-overview/admin-project-overview.component';
import { ProjectModalsComponent } from './shared/project-modals/project-modals.component';
import { PricingComponent } from './project-calculation/pricing/pricing.component';
import { GuestPageComponent } from './guest-page/guest-page.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ProjectCalculationComponent,
    BasicInfoComponent,
    EquipmentInventoryComponent,
    ServicesComponent,
    ContractComponent,
    AppFrameComponent,
    MasterfileManagementComponent,
    AdminProjectOverviewComponent,
    ProjectModalsComponent,
    PricingComponent,
    GuestPageComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    IxModule.forRoot(),
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AuthModule.forRoot({
      ...env.auth,
      httpInterceptor: {
        ...env.httpInterceptor
      }
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi())
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
